<template>
    <div>
        <b-row v-if="!$store.state.registration.newUser">
            <b-col>
                <a class="btn btn-block btn-primary" href="../woningaanbod">Naar Woningaanbod</a>
            </b-col>
        </b-row>
        <br  v-if="!$store.state.registration.newUser"/>
        <b-row>
            <b-col sm="12">
            <h2>
                Meest relevante vragen & antwoorden
            </h2>
            <div class="card" v-for="question in faq" :key="question.id">
                <div class="card-header question-card" v-b-toggle="'question_'+question.id">
                    <i class="fad fax fa-question-circle"></i> {{question.question}}
                </div>
                <b-collapse v-bind:id="'question_'+question.id" class="card-body" accordion="faq" v-html="question.answer">

                </b-collapse>
            </div>
            <br/>
            <h4 class="text-right">
                <a href="../faq" target="_blank">
                    Antwoord niet gevonden?
                </a>
            </h4>
            </b-col>
        </b-row>
        <b-row>
            <b-col sm="12" class="spacer d-none d-sm-block">&nbsp;</b-col>
        </b-row>
        <b-row>
            <b-col sm="12">
                <ul class="list-unstyled" id="listOfSteps">
                    <li v-for="step in processSteps.steps" :key="step.id">
                        <p v-bind:class="{'active-step': step.id-1 === currentStep}">
                            <i v-bind:class="[step.icon, 'fal', 'fax']"></i>
                            <span
                                    v-if="$store.state.registration.newUser && step.id-1 >= currentStep"
                            >
                                Stap {{step.id}} - {{step.text}}
                            </span>
                            <a
                                    v-else-if="$store.state.registration.newUser && step.id-1 < currentStep"
                                    @click="$emit('goToStep', step.id-1)"
                                    class="pointer"
                            >
                                Stap {{step.id}} - {{step.text}}
                                <i class="fal fax fa-check"></i>
                            </a>
                            <a
                                    v-else
                                    @click="$emit('goToStep', step.id-1)"
                                    class="pointer"
                            >
                                {{step.text}}
                            </a>
                        </p>
                    </li>
                </ul>
            </b-col>
        </b-row>
    </div>
</template>

<script>
  export default {
    props: [
      'faq',
      'processSteps',
      'currentStep'
    ],
    data: () => {
      return {

      }
    },
    name: 'Faq',
    methods: {
      setActiveInput(data) {
        if (data !== this.activeInput) {
          this.activeInput = data
        }
      }
    }
  }
</script>

<style scoped>
.card{
  margin-bottom: 2px;
}

.btn-blue{
    background-color: #2580bf !important
}
</style>